import React, { useEffect, useState } from "react";
import VerificationPopUp from "../../VerificationPop/VerificationPopUp";
import Popup from "../../../components/popup/Popup";
import {
  AdminDetailFieldLabel,
  AdminHeaderAction,
  adminWizardInputClasses,
} from "../../AdminDashboard/shared/adminUx";
import {
  BUSINESS_WIZARD_CONTENT_WIDE_CLASS,
  BUSINESS_FORM_SECTION_GAP_CLASS,
  BUSINESS_FORM_ACTION_ROW_END_CLASS,
} from "../shared/businessLayoutSpec";

const SettingsField = ({ id, label, placeholder, className = "" }) => (
  <div className={`space-y-1 ${className}`}>
    <AdminDetailFieldLabel htmlFor={id}>{label}</AdminDetailFieldLabel>
    <input
      id={id}
      type="text"
      placeholder={placeholder}
      className={`${adminWizardInputClasses(false)} lg:bg-pastalblue w-full`}
    />
  </div>
);

const BusinessCont = () => {
  const [verificationmobile, setVerificationmobile] = useState(false);
  const [verificationemail, setVerificationemail] = useState(false);
  const [ShowCrossButton] = useState(true);

  useEffect(() => {
    if (verificationmobile || verificationemail) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
      document.body.style.width = "auto";
    }
  }, [verificationmobile, verificationemail]);

  return (
    <>
      <div className={BUSINESS_WIZARD_CONTENT_WIDE_CLASS}>
        <SettingsField id="mobile-current" label="Mobile number" placeholder="Mobile number" />
        <SettingsField
          id="mobile-new"
          label="New mobile number"
          placeholder="Enter new mobile number"
          className="mt-5"
        />
        <div className={BUSINESS_FORM_ACTION_ROW_END_CLASS}>
          <AdminHeaderAction type="button" onClick={() => setVerificationmobile(true)}>
            Verify
          </AdminHeaderAction>
        </div>
        {verificationmobile && (
          <Popup setTrigger={() => setVerificationmobile(false)} ShowCrossButton={ShowCrossButton}>
            <VerificationPopUp
              closePopup={() => setVerificationmobile(false)}
              firstMainHeading="Verify your mobile number"
              label="Varification code"
              placeholder="Enter the 5-digit code"
              secondMainHeading="Mobile number verified"
              secondP="Your mobile number has been successfully verified. Your account is now securely linked for important updates and communication."
              smallPara="Verifying your mobile number is a crucial step in securing your business account and ensuring smooth communication."
              buttonText="Submit"
            />
          </Popup>
        )}
      </div>

      <div className={`${BUSINESS_WIZARD_CONTENT_WIDE_CLASS} ${BUSINESS_FORM_SECTION_GAP_CLASS}`}>
        <SettingsField id="office-current" label="Office number" placeholder="Office number" />
        <SettingsField
          id="office-new"
          label="New office number"
          placeholder="Enter new office number"
          className="mt-5"
        />
        <div className={BUSINESS_FORM_ACTION_ROW_END_CLASS}>
          <AdminHeaderAction type="button">Save</AdminHeaderAction>
        </div>
      </div>

      <div className={`${BUSINESS_WIZARD_CONTENT_WIDE_CLASS} ${BUSINESS_FORM_SECTION_GAP_CLASS}`}>
        <SettingsField id="email-current" label="Business email" placeholder="Business email" />
        <SettingsField
          id="email-new"
          label="New business email"
          placeholder="Enter new business email"
          className="mt-5"
        />
        <div className={BUSINESS_FORM_ACTION_ROW_END_CLASS}>
          <AdminHeaderAction type="button" onClick={() => setVerificationemail(true)}>
            Verify
          </AdminHeaderAction>
        </div>
        {verificationemail && (
          <Popup setTrigger={() => setVerificationemail(false)} ShowCrossButton={ShowCrossButton}>
            <VerificationPopUp
              closePopup={() => setVerificationemail(false)}
              firstMainHeading="Business email verification"
              label="Varification code"
              placeholder="Enter the verification code"
              secondMainHeading="Business email verified"
              secondP="Your business email has been successfully verified. You're now ready to receive updates and notifications directly to your inbox."
              smallPara="Email verification helps maintain your account's security and allows you to recover your account if needed."
              buttonText="Submit"
            />
          </Popup>
        )}
      </div>

      <div className={`${BUSINESS_WIZARD_CONTENT_WIDE_CLASS} ${BUSINESS_FORM_SECTION_GAP_CLASS}`}>
        <SettingsField id="website-current" label="Website" placeholder="Website.com" />
        <SettingsField
          id="website-new"
          label="New website"
          placeholder="Enter new website"
          className="mt-5"
        />
        <div className={BUSINESS_FORM_ACTION_ROW_END_CLASS}>
          <AdminHeaderAction type="button">Save</AdminHeaderAction>
        </div>
      </div>
    </>
  );
};

export default BusinessCont;
